import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiError, Empregador } from '../../api.service';
import { ModoCameraFacial } from '../../shared/camera-facial.component';
import { ServicoCameraFacial } from '../../shared/servico-camera-facial';
import { ServicoFluxoFacial } from '../../shared/servico-fluxo-facial';
import { ServicoFormatacao } from '../../shared/servico-formatacao';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { CaixaFaceDetectada, ServicoReconhecimentoFacial } from '../../shared/servico-reconhecimento-facial';
import { ServicoEstadoTerminalLocal } from '../../core/terminal/servico-estado-terminal-local';
import { ServicoCacheBiometricoLocal } from './servico-cache-biometrico-local';
import { ServicoConexaoTerminal } from './servico-conexao-terminal';
import { RegistroPontoPendente, ResumoRegistroPontoPendente, ServicoFilaPontoLocal } from './servico-fila-ponto-local';
import { ServicoIdentificacaoBiometricaLocal } from './servico-identificacao-biometrica-local';
import { ModalConfirmacaoPontoComponent } from './modal-confirmacao-ponto.component';
import { PainelAtivacaoTerminalComponent } from './painel-ativacao-terminal.component';
import { PainelCameraRegistroComponent } from './painel-camera-registro.component';
import { PainelFilaOfflineComponent } from './painel-fila-offline.component';
import { PainelRegistroManualComponent } from './painel-registro-manual.component';
import { PainelStatusTerminalComponent } from './painel-status-terminal.component';
import { RelogioRegistradorComponent } from './relogio-registrador.component';
import { EstadoConfirmacaoPonto, ServicoConfirmacaoPonto } from './servico-confirmacao-ponto';
import { EstadoCameraRegistrador, ServicoEstadoCameraRegistrador } from './servico-estado-camera-registrador';
import { EstadoCacheBiometricoRegistrador, ServicoEstadoCacheBiometricoRegistrador } from './servico-estado-cache-biometrico-registrador';
import { EstadoFilaOfflineRegistrador, ServicoEstadoFilaOfflineRegistrador } from './servico-estado-fila-offline-registrador';
import { ServicoGuardaSincronizacaoRegistrador } from './servico-guarda-sincronizacao-registrador';
import { ServicoRegistroFacial } from './servico-registro-facial';
import { ResultadoSincronizacaoLocal, ServicoSincronizacaoPontoLocal } from './servico-sincronizacao-ponto-local';
import { ServicoValidacaoAberturaCameraRegistrador } from './servico-validacao-abertura-camera-registrador';
import { ServicoVigilanciaCameraRegistrador } from './servico-vigilancia-camera-registrador';
import { ServicoVozRegistro } from './servico-voz-registro';

@Component({
  selector: 'app-tela-registrador',
  standalone: true,
  imports: [
    CommonModule,
    ModalConfirmacaoPontoComponent,
    PainelAtivacaoTerminalComponent,
    PainelCameraRegistroComponent,
    PainelFilaOfflineComponent,
    PainelRegistroManualComponent,
    PainelStatusTerminalComponent,
    RelogioRegistradorComponent
  ],
  templateUrl: './tela-registrador.component.html',
  styleUrls: ['./tela-registrador.component.css']
})
export class TelaRegistradorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() agora = new Date();
  @Input() dataFormatada = '';
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() terminalPublico = false;
  @Input() terminalAutorizado = false;
  @Input() terminalNome = '';
  @Input() terminalToken = '';
  @Input() zoomCamera?: number;
  @Input() areaLeituraCameraPercentual?: number;
  @Input() codigoAtivacao = '';
  @Input() ativandoTerminal = false;

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() codigoAtivacaoChange = new EventEmitter<string>();
  @Output() ativarTerminal = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();

  online = true;
  ultimaConexaoOnline: Date | null = null;
  registrosPendentesOffline = 0;
  totalPendentesOffline = 0;
  totalFalhasOffline = 0;
  totalSincronizadosOffline = 0;
  filaOfflineVisivel = false;
  resumosFilaOffline: ResumoRegistroPontoPendente[] = [];
  cacheBiometricoValido = false;
  totalFuncionariosCache = 0;
  sincronizandoOffline = false;
  cameraAtiva = false;
  cameraModo: ModoCameraFacial = 'registro';
  rostoDetectado = false;
  provaVidaOk = false;
  capturando = false;
  mensagemCamera = '';
  caixaFace?: CaixaFaceDetectada;
  zoomVisualCamera = 1;
  confirmacaoPontoVisivel = false;
  confirmacaoPontoTitulo = 'Ponto registrado com sucesso.';
  confirmacaoPontoNome = '';
  confirmacaoPontoHorario = '';
  detectorDisponivel = false;
  private fotoCapturada = '';
  private descritorFacialAtual: number[] = [];
  private monitoramentoFacial?: number;
  private vigilanciaCamera?: number;
  private aoMudarVisibilidade?: () => void;
  private monitoramentoOcupado = false;
  private analiseIniciadaEm = 0;
  private reabrindoCamera = false;
  private buscaAposLente?: number;
  private registroAutomaticoDisparado = false;
  private registroCooldownAte = 0;
  private ultimaMensagemFalhaRegistro = '';
  private ultimaFalhaRegistroEm = 0;
  private ultimoFuncionarioRegistradoId = '';
  private ultimoFuncionarioRegistradoNome = '';
  private ultimoDescritorRegistrado: number[] = [];
  private ultimoFuncionarioRegistradoAte = 0;
  private ultimoPontoDataHora = '';
  private ultimaMensagemBatidaRegistrada = '';
  private ultimoAvisoFuncionarioRegistradoEm = 0;
  private aguardandoProximaPessoaAte = 0;
  private rostoAusenteDesde = 0;
  private falhasIdentificacaoSequenciais = 0;
  private aguardandoSaidaDoRosto = false;
  private assinaturaConexao?: Subscription;
  private assinaturaConfirmacaoPonto?: Subscription;
  private atualizacaoFilaOffline?: number;
  private promessaPreparacaoOnline?: Promise<ResultadoSincronizacaoLocal>;

  constructor(
    private readonly servicoCameraFacial: ServicoCameraFacial,
    private readonly servicoCacheBiometricoLocal: ServicoCacheBiometricoLocal,
    private readonly servicoConexaoTerminal: ServicoConexaoTerminal,
    private readonly servicoEstadoTerminalLocal: ServicoEstadoTerminalLocal,
    private readonly servicoFilaPontoLocal: ServicoFilaPontoLocal,
    private readonly servicoFluxoFacial: ServicoFluxoFacial,
    private readonly servicoFormatacao: ServicoFormatacao,
    private readonly servicoIdentificacaoBiometricaLocal: ServicoIdentificacaoBiometricaLocal,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoReconhecimentoFacial: ServicoReconhecimentoFacial,
    private readonly servicoConfirmacaoPonto: ServicoConfirmacaoPonto,
    private readonly servicoEstadoCameraRegistrador: ServicoEstadoCameraRegistrador,
    private readonly servicoEstadoCacheBiometricoRegistrador: ServicoEstadoCacheBiometricoRegistrador,
    private readonly servicoEstadoFilaOfflineRegistrador: ServicoEstadoFilaOfflineRegistrador,
    private readonly servicoGuardaSincronizacaoRegistrador: ServicoGuardaSincronizacaoRegistrador,
    private readonly servicoRegistroFacial: ServicoRegistroFacial,
    private readonly servicoSincronizacaoPontoLocal: ServicoSincronizacaoPontoLocal,
    private readonly servicoValidacaoAberturaCameraRegistrador: ServicoValidacaoAberturaCameraRegistrador,
    private readonly servicoVozRegistro: ServicoVozRegistro
  ) {}

  private readonly servicoVigilanciaCamera = new ServicoVigilanciaCameraRegistrador();

  ngOnInit() {
    this.servicoVozRegistro.iniciar();
    this.assinaturaConfirmacaoPonto = this.servicoConfirmacaoPonto.estado$.subscribe(estado =>
      this.aplicarEstadoConfirmacaoPonto(estado)
    );
    this.assinaturaConexao = this.servicoConexaoTerminal.online$.subscribe(online => this.aoAlterarConexao(online));
    this.ultimaConexaoOnline = this.servicoConexaoTerminal.ultimaConexao;
    this.assinaturaConexao.add(
      this.servicoConexaoTerminal.ultimaConexaoOnline$.subscribe(data => this.ultimaConexaoOnline = data)
    );
    this.atualizacaoFilaOffline = window.setInterval(() => this.atualizarFilaOffline(), 10000);
    void this.atualizarFilaOffline();
    void this.atualizarEstadoCacheBiometrico();
    this.tentarAbrirCameraAutomatica();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.servicoEstadoCameraRegistrador.deveFecharPorPerdaDeAutorizacao(
      this.terminalPublico,
      this.terminalAutorizado,
      this.cameraAtiva
    )) {
      this.fecharCamera();
    }
    if (changes['terminalAutorizado'] || changes['empregadorSelecionado'] || changes['terminalPublico']) {
      this.tentarAbrirCameraAutomatica();
    }
    if (changes['terminalAutorizado'] || changes['terminalToken'] || changes['terminalPublico']) {
      void this.prepararOperacaoOnline();
    }
    if (changes['zoomCamera'] || changes['areaLeituraCameraPercentual']) {
      this.aplicarConfiguracaoCameraTerminal();
    }
  }

  ngOnDestroy() {
    this.assinaturaConexao?.unsubscribe();
    this.assinaturaConfirmacaoPonto?.unsubscribe();
    if (this.atualizacaoFilaOffline) {
      window.clearInterval(this.atualizacaoFilaOffline);
      this.atualizacaoFilaOffline = undefined;
    }
    this.limparConfirmacaoPonto();
    this.fecharCamera();
  }

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.alterarEmpregador.emit();
  }

  async abrirCameraRegistro() {
    this.servicoVozRegistro.prepararAudio();
    const contexto = this.contextoAberturaCamera();
    if (this.servicoValidacaoAberturaCameraRegistrador.deveAtualizarCacheAntesDeAvaliar(contexto)) {
      await this.atualizarEstadoCacheBiometrico();
    }

    const resultado = this.servicoValidacaoAberturaCameraRegistrador.avaliar(this.contextoAberturaCamera());
    if (!resultado.permitido) {
      this.mensagem.emit(resultado.mensagem || 'Nao foi possivel abrir a camera para registro.');
      return;
    }

    await this.abrirCamera('registro');
  }

  private contextoAberturaCamera() {
    return {
      empregadorSelecionado: this.empregadorSelecionado,
      terminalPublico: this.terminalPublico,
      terminalAutorizado: this.terminalAutorizado,
      online: this.online,
      terminalToken: this.terminalToken,
      cacheBiometricoValido: this.cacheBiometricoValido
    };
  }

  private tentarAbrirCameraAutomatica() {
    if (!this.servicoEstadoCameraRegistrador.deveAbrirAutomaticamente(
      this.terminalPublico,
      this.terminalAutorizado,
      this.empregadorSelecionado,
      this.cameraAtiva
    )) {
      return;
    }

    window.setTimeout(() => this.abrirCameraRegistro(), 250);
  }

  private aplicarConfiguracaoCameraTerminal() {
    this.servicoCameraFacial.configurar({
      zoomCamera: this.zoomCamera,
      areaLeituraCameraPercentual: this.areaLeituraCameraPercentual
    });
    this.zoomVisualCamera = this.servicoCameraFacial.fatorZoomVisual();
  }

  private async abrirCamera(modo: ModoCameraFacial) {
    try {
      this.fotoCapturada = '';
      this.fecharCamera();
      this.aplicarConfiguracaoCameraTerminal();
      await this.servicoCameraFacial.abrir();
      this.aplicarEstadoCameraRegistrador(this.servicoEstadoCameraRegistrador.estadoAbertura(modo));
      this.servicoReconhecimentoFacial.resetarProvaVida();
      this.mensagem.emit(this.servicoFluxoFacial.mensagemAberturaCamera(modo));
      window.setTimeout(async () => {
        this.servicoCameraFacial.conectarVideo();
        this.detectorDisponivel = await this.servicoReconhecimentoFacial.carregarDetector();
        this.mensagemCamera = this.detectorDisponivel
          ? 'Procurando rosto na camera.'
          : 'Nao foi possivel carregar o detector facial.';
        this.iniciarMonitoramentoFacial();
        this.iniciarVigilanciaCamera();
      }, 0);
    } catch {
      this.mensagem.emit('Nao foi possivel acessar a camera. Verifique permissao do navegador e webcam.');
    }
  }

  async capturarERegistrar() {
    const fotoCapturada = this.servicoCameraFacial.capturarImagemBase64();
    if (!fotoCapturada) {
      this.registroAutomaticoDisparado = false;
      this.mensagem.emit('Camera ainda nao esta pronta.');
      return;
    }

    if (!this.servicoFluxoFacial.capturaValida(this.rostoDetectado, this.provaVidaOk, this.descritorFacialAtual)) {
      this.registroAutomaticoDisparado = false;
      this.mensagem.emit(this.servicoFluxoFacial.mensagemCapturaInvalida(this.detectorDisponivel));
      return;
    }

    if (this.deveAguardarConfirmacaoOuCooldown()) {
      this.registroAutomaticoDisparado = false;
      return;
    }

    if (this.deveRepetirAvisoPontoJaRegistrado()) {
      this.registroAutomaticoDisparado = false;
      this.avisarBatidaJaRegistrada();
      return;
    }

    this.fotoCapturada = fotoCapturada;

    if (this.terminalPublico && !this.online) {
      await this.registrarPontoOfflineLocal();
      return;
    }

    if (this.terminalPublico && this.online) {
      try {
        const pendentesAntes = await this.servicoFilaPontoLocal.contarPendentesSincronizaveis(this.terminalToken);
        if (pendentesAntes > 0) {
          this.mensagemCamera = this.servicoGuardaSincronizacaoRegistrador.mensagemAguardandoSincronizacao();
          const resultado = await this.sincronizarPendenciasOffline();
          if (this.servicoGuardaSincronizacaoRegistrador.deveProtegerLeituraAposSincronizacao(resultado.sincronizados)) {
            this.protegerLeituraAposSincronizacao();
            return;
          }
        }

        if (await this.possuiPontoLocalRecenteNaCaptura()) {
          return;
        }
      } catch {
        // Se a fila local falhar, o registro online segue com o backend.
      }
    }

    this.capturando = true;
    this.servicoRegistroFacial.registrar({
      terminalPublico: this.terminalPublico,
      empregadorId: this.empregadorSelecionado,
      imagemFacialBase64: this.fotoCapturada,
      descritorFacial: this.descritorFacialAtual,
      tokenTerminal: this.terminalToken
    }).subscribe({
      next: registro => {
        this.registrarCooldownFuncionario(
          registro.funcionario.id || '',
          registro.funcionario.nome,
          this.descritorFacialAtual,
          registro.dataHora
        );
        this.exibirConfirmacaoPonto('Ponto registrado com sucesso.', registro.funcionario.nome, registro.dataHora);
        this.servicoVozRegistro.falar(`Ponto registrado. ${registro.funcionario.nome}`, this.servicoCameraFacial.ehCameraMobile());
        if (this.terminalPublico) {
          this.reiniciarCicloRegistroContinuo(4000, 'Ponto registrado. Aguarde a proxima leitura.');
        } else {
          this.fecharCamera();
        }
      },
      error: (error: ApiError) => {
        if (this.deveRepetirAvisoPontoJaRegistrado()) {
          this.avisarBatidaJaRegistrada();
          if (this.terminalPublico) {
            this.reiniciarCicloRegistroContinuo(4500, 'Batida ja registrada. Aguarde a proxima leitura.');
          } else {
            this.capturando = false;
            this.registroAutomaticoDisparado = false;
            this.fecharCamera();
          }
          return;
        }
        const mensagemErro = this.mensagemErroRegistroPonto(error);
        if (mensagemErro.includes('Batida registrada para esse horário')) {
          this.ultimaMensagemBatidaRegistrada = mensagemErro;
          this.registrarCooldownFuncionario(
            this.ultimoFuncionarioRegistradoId || 'servidor-em-foco',
            this.ultimoFuncionarioRegistradoNome,
            this.descritorFacialAtual
          );
        }
        this.emitirFalhaRegistro(mensagemErro);
        if (this.terminalPublico) {
          this.reiniciarCicloRegistroContinuo(4500, mensagemErro);
        } else {
          this.capturando = false;
          this.registroAutomaticoDisparado = false;
          this.fecharCamera();
        }
      }
    });
  }

  private exibirConfirmacaoPonto(titulo: string, nomeFuncionario: string, dataHora?: string) {
    this.ultimaMensagemFalhaRegistro = '';
    this.ultimaFalhaRegistroEm = 0;
    this.falhasIdentificacaoSequenciais = 0;
    this.aguardandoProximaPessoaAte = Date.now() + 4000;
    this.aguardandoSaidaDoRosto = true;
    this.rostoAusenteDesde = 0;
    this.servicoMensagemAplicacao.limpar();
    this.servicoConfirmacaoPonto.exibir(titulo, nomeFuncionario, this.horarioConfirmacao(dataHora));
  }

  private limparConfirmacaoPonto() {
    this.servicoConfirmacaoPonto.limpar();
  }

  private aplicarEstadoConfirmacaoPonto(estado: EstadoConfirmacaoPonto) {
    this.confirmacaoPontoVisivel = estado.visivel;
    this.confirmacaoPontoTitulo = estado.titulo;
    this.confirmacaoPontoNome = estado.nome;
    this.confirmacaoPontoHorario = estado.horario;
  }

  private reiniciarCicloRegistroContinuo(intervaloMs: number, mensagemCamera: string) {
    this.aplicarEstadoCameraRegistrador(
      this.servicoEstadoCameraRegistrador.estadoReinicioContinuo(this.estadoCameraAtual(), intervaloMs, mensagemCamera)
    );
    this.servicoReconhecimentoFacial.resetarProvaVida();
  }

  fecharCamera() {
    this.pararVigilanciaCamera();
    this.pararMonitoramentoFacial();
    this.servicoCameraFacial.fechar();
    this.aplicarEstadoCameraRegistrador(this.servicoEstadoCameraRegistrador.estadoFechado(this.cameraModo));
    this.servicoReconhecimentoFacial.resetarProvaVida();
  }

  private aplicarEstadoCameraRegistrador(estado: EstadoCameraRegistrador) {
    this.cameraAtiva = estado.cameraAtiva;
    this.cameraModo = estado.cameraModo;
    this.rostoDetectado = estado.rostoDetectado;
    this.provaVidaOk = estado.provaVidaOk;
    this.capturando = estado.capturando;
    this.mensagemCamera = estado.mensagemCamera;
    this.caixaFace = estado.caixaFace;
    this.detectorDisponivel = estado.detectorDisponivel;
    this.descritorFacialAtual = estado.descritorFacialAtual;
    this.registroAutomaticoDisparado = estado.registroAutomaticoDisparado;
    this.registroCooldownAte = estado.registroCooldownAte;
  }

  private estadoCameraAtual(): EstadoCameraRegistrador {
    return {
      cameraAtiva: this.cameraAtiva,
      cameraModo: this.cameraModo,
      rostoDetectado: this.rostoDetectado,
      provaVidaOk: this.provaVidaOk,
      capturando: this.capturando,
      mensagemCamera: this.mensagemCamera,
      caixaFace: this.caixaFace,
      detectorDisponivel: this.detectorDisponivel,
      descritorFacialAtual: this.descritorFacialAtual,
      registroAutomaticoDisparado: this.registroAutomaticoDisparado,
      registroCooldownAte: this.registroCooldownAte
    };
  }

  private iniciarMonitoramentoFacial() {
    this.pararMonitoramentoFacial();
    if (!this.detectorDisponivel) {
      return;
    }

    this.monitoramentoFacial = window.setInterval(() => this.detectarRosto(), 220);
    this.detectarRosto();
  }

  private pararMonitoramentoFacial() {
    if (this.monitoramentoFacial) {
      window.clearInterval(this.monitoramentoFacial);
      this.monitoramentoFacial = undefined;
    }
  }

  private iniciarVigilanciaCamera() {
    this.pararVigilanciaCamera();
    this.servicoVigilanciaCamera.resetar();
    this.servicoCameraFacial.onTrilhaEncerrada = () => void this.recuperarCamera();
    this.servicoCameraFacial.onTrilhaLiberada = () => this.aoAbrirLente();
    this.vigilanciaCamera = window.setInterval(
      () => this.vigiarCamera(),
      ServicoVigilanciaCameraRegistrador.INTERVALO_MS
    );
    this.aoMudarVisibilidade = () => this.vigiarCamera();
    document.addEventListener('visibilitychange', this.aoMudarVisibilidade);
  }

  private pararVigilanciaCamera() {
    this.servicoCameraFacial.onTrilhaEncerrada = undefined;
    this.servicoCameraFacial.onTrilhaLiberada = undefined;
    this.pararBuscaAposLente();
    if (this.vigilanciaCamera) {
      window.clearInterval(this.vigilanciaCamera);
      this.vigilanciaCamera = undefined;
    }
    if (this.aoMudarVisibilidade) {
      document.removeEventListener('visibilitychange', this.aoMudarVisibilidade);
      this.aoMudarVisibilidade = undefined;
    }
  }

  private vigiarCamera() {
    const acao = this.servicoVigilanciaCamera.avaliar({
      cameraAtiva: this.cameraAtiva,
      reabrindo: this.reabrindoCamera,
      trilhaViva: this.servicoCameraFacial.trilhaViva(),
      videoPausado: this.servicoCameraFacial.videoPausado(),
      videoSemQuadro: this.servicoCameraFacial.videoSemQuadro(),
      analiseTravadaMs: this.monitoramentoOcupado && this.analiseIniciadaEm
        ? Date.now() - this.analiseIniciadaEm
        : 0
    });
    if (acao === 'reproduzir') {
      this.servicoCameraFacial.garantirReproducao();
      return;
    }
    if (acao === 'destravar-analise') {
      this.monitoramentoOcupado = false;
      this.analiseIniciadaEm = 0;
      return;
    }
    if (acao === 'reabrir') {
      void this.recuperarCamera();
    }
  }

  private aoAbrirLente() {
    this.servicoVigilanciaCamera.marcarLenteLiberada();
    this.servicoCameraFacial.garantirReproducao();
    this.monitoramentoOcupado = false;
    this.analiseIniciadaEm = 0;
    this.registroAutomaticoDisparado = false;
    this.servicoReconhecimentoFacial.resetarProvaVida();
    this.mensagemCamera = 'Procurando rosto na camera.';
    this.iniciarBuscaAposLente();
  }

  private iniciarBuscaAposLente() {
    this.pararBuscaAposLente();
    let tentativas = 0;
    this.buscaAposLente = window.setInterval(() => {
      tentativas += 1;
      void this.detectarRosto();
      if (tentativas >= 12 || this.caixaFace) {
        this.pararBuscaAposLente();
      }
    }, 160);
  }

  private pararBuscaAposLente() {
    if (this.buscaAposLente) {
      window.clearInterval(this.buscaAposLente);
      this.buscaAposLente = undefined;
    }
  }

  private async recuperarCamera() {
    if (this.reabrindoCamera || !this.terminalPublico || !this.terminalAutorizado) {
      return;
    }
    this.reabrindoCamera = true;
    this.mensagemCamera = 'Reconectando a camera.';
    try {
      await this.abrirCamera('registro');
    } finally {
      this.reabrindoCamera = false;
      if (!this.cameraAtiva) {
        window.setTimeout(() => this.tentarAbrirCameraAutomatica(), 2000);
      }
    }
  }

  private async detectarRosto() {
    const video = this.servicoCameraFacial.videoAtual();
    if (!video || !this.detectorDisponivel || this.monitoramentoOcupado || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      return;
    }

    const quadroEscuro = this.servicoCameraFacial.quadroEscuro();
    if (this.servicoVigilanciaCamera.notificarQuadroEscuro(quadroEscuro) === 'lente-aberta') {
      this.aoAbrirLente();
    }
    if (quadroEscuro) {
      this.rostoDetectado = false;
      this.caixaFace = undefined;
      this.mensagemCamera = 'Abra a lente e posicione o rosto na camera.';
      return;
    }

    this.monitoramentoOcupado = true;
    this.analiseIniciadaEm = Date.now();
    try {
      const cameraMobile = this.servicoCameraFacial.ehCameraMobile(video);
      const analise = await this.servicoReconhecimentoFacial.analisarComTempoLimite(video, cameraMobile);

      this.rostoDetectado = analise.rostoDetectado;
      this.provaVidaOk = analise.provaVidaOk;
      this.descritorFacialAtual = analise.descritorFacial;
      this.caixaFace = analise.caixaFace;
      this.mensagemCamera = analise.mensagem;

      if (!this.rostoDetectado) {
        this.registrarRostoAusente();
        return;
      }

      this.rostoAusenteDesde = 0;

      if (this.deveAguardarConfirmacaoOuCooldown()) {
        return;
      }

      if (this.deveRepetirAvisoPontoJaRegistrado()) {
        this.avisarBatidaJaRegistrada();
        return;
      }

      if (this.servicoEstadoCameraRegistrador.deveDispararRegistroAutomatico(
        this.rostoDetectado,
        this.provaVidaOk,
        this.registroAutomaticoDisparado
      )) {
        this.registroAutomaticoDisparado = true;
        this.mensagemCamera = this.servicoEstadoCameraRegistrador.mensagemIdentificandoFuncionario();
        window.setTimeout(() => this.capturarERegistrar(), 100);
      }
    } catch {
      this.aplicarEstadoCameraRegistrador(this.servicoEstadoCameraRegistrador.estadoErroAnalise(this.estadoCameraAtual()));
    } finally {
      this.monitoramentoOcupado = false;
      this.analiseIniciadaEm = 0;
    }
  }

  private async atualizarFilaOffline() {
    if (!this.terminalPublico) {
      this.aplicarEstadoFilaOffline(this.servicoEstadoFilaOfflineRegistrador.vazio());
      return;
    }

    try {
      if (!this.terminalToken) {
        this.aplicarEstadoFilaOffline(this.servicoEstadoFilaOfflineRegistrador.vazio());
        return;
      }
      const estadoFila = await this.servicoFilaPontoLocal.consultarEstado(this.terminalToken);
      this.aplicarEstadoFilaOffline(this.servicoEstadoFilaOfflineRegistrador.doEstadoLocal(estadoFila));
    } catch {
      return;
    }
  }

  alternarFilaOffline() {
    this.filaOfflineVisivel = !this.filaOfflineVisivel;
    if (this.filaOfflineVisivel) {
      this.atualizarFilaOffline();
    }
  }

  private aplicarEstadoFilaOffline(estado: EstadoFilaOfflineRegistrador) {
    this.registrosPendentesOffline = estado.registrosPendentesOffline;
    this.resumosFilaOffline = estado.resumosFilaOffline;
    this.totalPendentesOffline = estado.totalPendentesOffline;
    this.totalFalhasOffline = estado.totalFalhasOffline;
    this.totalSincronizadosOffline = estado.totalSincronizadosOffline;
  }

  private exibirRegistroNaFilaOffline(registro: RegistroPontoPendente) {
    this.filaOfflineVisivel = true;
    this.aplicarEstadoFilaOffline(
      this.servicoEstadoFilaOfflineRegistrador.incluindo(this.estadoFilaOfflineAtual(), registro)
    );
  }

  private estadoFilaOfflineAtual(): EstadoFilaOfflineRegistrador {
    return {
      registrosPendentesOffline: this.registrosPendentesOffline,
      resumosFilaOffline: this.resumosFilaOffline,
      totalPendentesOffline: this.totalPendentesOffline,
      totalFalhasOffline: this.totalFalhasOffline,
      totalSincronizadosOffline: this.totalSincronizadosOffline
    };
  }

  private aoAlterarConexao(online: boolean) {
    this.online = online;
    if (online) {
      void this.prepararOperacaoOnline();
    } else {
      this.atualizarEstadoCacheBiometrico();
    }
  }

  private async prepararOperacaoOnline(): Promise<ResultadoSincronizacaoLocal> {
    const vazio: ResultadoSincronizacaoLocal = { total: 0, sincronizados: 0, falhas: 0 };
    if (!this.terminalPublico || !this.terminalAutorizado || !this.terminalToken || !this.online) {
      return vazio;
    }

    if (this.promessaPreparacaoOnline) {
      return this.promessaPreparacaoOnline;
    }

    this.promessaPreparacaoOnline = this.executarPreparacaoOnline();
    try {
      return await this.promessaPreparacaoOnline;
    } finally {
      this.promessaPreparacaoOnline = undefined;
    }
  }

  private async executarPreparacaoOnline(): Promise<ResultadoSincronizacaoLocal> {
    const resultado = await this.sincronizarPendenciasOffline();
    await this.atualizarCacheBiometricoOnline();
    return resultado;
  }

  private async atualizarCacheBiometricoOnline() {
    try {
      const estado = await this.servicoCacheBiometricoLocal.atualizarCache(this.terminalToken);
      this.aplicarEstadoCacheBiometrico(this.servicoEstadoCacheBiometricoRegistrador.doEstadoLocal(estado));
    } catch {
      await this.atualizarEstadoCacheBiometrico();
    }
  }

  private async atualizarEstadoCacheBiometrico() {
    try {
      if (!this.terminalToken) {
        this.aplicarEstadoCacheBiometrico(this.servicoEstadoCacheBiometricoRegistrador.vazio());
        return;
      }
      const estado = await this.servicoCacheBiometricoLocal.estado(this.terminalToken);
      this.aplicarEstadoCacheBiometrico(this.servicoEstadoCacheBiometricoRegistrador.doEstadoLocal(estado));
    } catch {
      this.aplicarEstadoCacheBiometrico(this.servicoEstadoCacheBiometricoRegistrador.vazio());
    }
  }

  private aplicarEstadoCacheBiometrico(estado: EstadoCacheBiometricoRegistrador) {
    this.cacheBiometricoValido = estado.cacheBiometricoValido;
    this.totalFuncionariosCache = estado.totalFuncionariosCache;
  }

  private async sincronizarPendenciasOffline(): Promise<ResultadoSincronizacaoLocal> {
    const vazio: ResultadoSincronizacaoLocal = { total: 0, sincronizados: 0, falhas: 0 };
    if (!this.terminalToken) {
      return vazio;
    }

    this.sincronizandoOffline = true;
    try {
      const resultado = await this.servicoSincronizacaoPontoLocal.sincronizarPendentes(this.terminalToken);
      const mensagemResultado = this.servicoSincronizacaoPontoLocal.mensagemResultado(resultado);
      if (mensagemResultado) {
        this.mensagem.emit(mensagemResultado);
      }
      return resultado;
    } catch (erro) {
      this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro as ApiError, 'Nao foi possivel sincronizar registros offline.'));
      return { total: 0, sincronizados: 0, falhas: 1 };
    } finally {
      this.sincronizandoOffline = false;
      await this.atualizarFilaOffline();
    }
  }

  private async possuiPontoLocalRecenteNaCaptura() {
    if (!this.terminalToken || !this.descritorFacialAtual.length) {
      return false;
    }

    const identificacao = await this.servicoIdentificacaoBiometricaLocal.identificar(this.descritorFacialAtual, this.terminalToken);
    if (!identificacao.identificado || !identificacao.funcionario) {
      return false;
    }

    const pontoRecente = await this.servicoFilaPontoLocal.possuiRegistroRecenteDoFuncionario(
      this.terminalToken,
      identificacao.funcionario.funcionarioId,
      this.servicoGuardaSincronizacaoRegistrador.intervaloMinimoRepeticaoMs
    );
    if (!pontoRecente) {
      return false;
    }

    this.registrarCooldownFuncionario(
      identificacao.funcionario.funcionarioId,
      identificacao.funcionario.nome,
      this.descritorFacialAtual
    );
    this.avisarBatidaJaRegistrada();
    return true;
  }

  private protegerLeituraAposSincronizacao() {
    this.ultimoFuncionarioRegistradoId = 'sincronizacao-offline';
    this.ultimoFuncionarioRegistradoNome = '';
    this.ultimoDescritorRegistrado = [];
    this.ultimoFuncionarioRegistradoAte = Date.now() + this.servicoGuardaSincronizacaoRegistrador.intervaloMinimoRepeticaoMs;
    this.ultimoAvisoFuncionarioRegistradoEm = 0;
    this.aguardandoSaidaDoRosto = true;
    this.rostoAusenteDesde = 0;
    this.reiniciarCicloRegistroContinuo(
      4000,
      this.servicoGuardaSincronizacaoRegistrador.mensagemSincronizacaoConcluida()
    );
  }

  private async registrarPontoOfflineLocal() {
    this.capturando = true;
    const avaliacaoTerminal = this.servicoEstadoTerminalLocal.avaliarOperacaoOffline(this.terminalToken);
    if (!avaliacaoTerminal.permitido) {
      this.emitirFalhaOffline(avaliacaoTerminal.motivo || 'Terminal sem autorizacao offline.');
      return;
    }

    const identificacao = await this.servicoIdentificacaoBiometricaLocal.identificar(this.descritorFacialAtual, this.terminalToken);
    if (!identificacao.identificado || !identificacao.funcionario) {
      this.emitirFalhaOffline(identificacao.motivo || 'Servidor nao encontrado no cache offline.');
      return;
    }

    let pontoRecente = false;
    try {
      pontoRecente = await this.servicoFilaPontoLocal.possuiRegistroRecenteDoFuncionario(
        this.terminalToken,
        identificacao.funcionario.funcionarioId,
        this.servicoGuardaSincronizacaoRegistrador.intervaloMinimoRepeticaoMs
      );
    } catch {
      pontoRecente = false;
    }
    if (pontoRecente) {
      this.emitirFalhaOffline(this.servicoGuardaSincronizacaoRegistrador.mensagemPontoJaRegistrado());
      return;
    }

    try {
      const registro = await this.servicoFilaPontoLocal.criarPendente(this.terminalToken, {
        imagemFacialBase64: this.fotoCapturada,
        imagemFacialMimeType: 'image/jpeg',
        descritorFacial: this.descritorFacialAtual,
        funcionarioId: identificacao.funcionario.funcionarioId,
        funcionarioNome: identificacao.funcionario.nome,
        funcionarioMatricula: identificacao.funcionario.matricula
      });
      this.exibirRegistroNaFilaOffline(registro);
      await this.atualizarFilaOffline();
      if (!this.resumosFilaOffline.some(item => item.offlineId === registro.offlineId)) {
        this.exibirRegistroNaFilaOffline(registro);
      }
    } catch {
      this.emitirFalhaOffline('Nao foi possivel gravar o ponto offline neste navegador.');
      return;
    }
    const nomeFuncionario = identificacao.funcionario.nome;
    this.registrarCooldownFuncionario(
      identificacao.funcionario.funcionarioId,
      nomeFuncionario,
      this.descritorFacialAtual
    );
    this.exibirConfirmacaoPonto('Ponto registrado offline.', nomeFuncionario);
    this.servicoVozRegistro.falar(`Ponto registrado offline. ${nomeFuncionario}`, this.servicoCameraFacial.ehCameraMobile());
    this.reiniciarCicloRegistroContinuo(4000, 'Ponto offline gravado. Aguardando sincronizacao.');
  }

  private emitirFalhaOffline(mensagemErro: string) {
    this.emitirFalhaRegistro(mensagemErro);
    this.reiniciarCicloRegistroContinuo(5000, mensagemErro);
  }

  private emitirFalhaRegistro(mensagemErro: string) {
    const agora = Date.now();
    const repetida = this.ultimaMensagemFalhaRegistro === mensagemErro && agora - this.ultimaFalhaRegistroEm < 10000;
    if (repetida) {
      return;
    }

    this.ultimaMensagemFalhaRegistro = mensagemErro;
    this.ultimaFalhaRegistroEm = agora;
    this.mensagem.emit(mensagemErro);
    this.servicoVozRegistro.falar(mensagemErro, this.servicoCameraFacial.ehCameraMobile());
  }

  private mensagemErroRegistroPonto(error: ApiError) {
    const mensagemErro = this.servicoMensagemAplicacao.erroRegistroPonto(error);
    if (!mensagemErro.includes('Servidor nao identificado')) {
      this.falhasIdentificacaoSequenciais = 0;
      return mensagemErro;
    }

    this.falhasIdentificacaoSequenciais++;
    if (this.falhasIdentificacaoSequenciais >= 3) {
      return 'Servidor nao identificado. Procure o departamento pessoal.';
    }
    return mensagemErro;
  }

  private registrarCooldownFuncionario(
    funcionarioId: string,
    nomeFuncionario: string,
    descritorFacial: number[],
    dataHora?: string
  ) {
    this.ultimoFuncionarioRegistradoId = funcionarioId;
    this.ultimoFuncionarioRegistradoNome = nomeFuncionario;
    this.ultimoDescritorRegistrado = [...descritorFacial];
    this.ultimoFuncionarioRegistradoAte = Date.now() + 30000;
    this.ultimoPontoDataHora = dataHora || this.ultimoPontoDataHora;
    if (!this.ultimaMensagemBatidaRegistrada || dataHora) {
      this.ultimaMensagemBatidaRegistrada = this.servicoMensagemAplicacao.batidaJaRegistrada(
        nomeFuncionario,
        this.ultimoPontoDataHora
      );
    }
    this.ultimoAvisoFuncionarioRegistradoEm = 0;
    this.aguardandoSaidaDoRosto = true;
    this.rostoAusenteDesde = 0;
  }

  private deveRepetirAvisoPontoJaRegistrado() {
    return this.servicoGuardaSincronizacaoRegistrador.deveRepetirAvisoPontoJaRegistrado({
      aguardandoSaidaDoRosto: this.aguardandoSaidaDoRosto,
      funcionarioId: this.ultimoFuncionarioRegistradoId,
      validoAte: this.ultimoFuncionarioRegistradoAte,
      rostoDetectado: this.rostoDetectado
    });
  }

  private avisarBatidaJaRegistrada() {
    this.falhasIdentificacaoSequenciais = 0;
    const mensagem = this.ultimaMensagemBatidaRegistrada
      || this.servicoMensagemAplicacao.batidaJaRegistrada(this.ultimoFuncionarioRegistradoNome, this.ultimoPontoDataHora);
    this.ultimaMensagemBatidaRegistrada = mensagem;
    this.mensagemCamera = 'Batida ja registrada. Aguarde a proxima leitura.';
    this.emitirFalhaRegistro(mensagem);
  }

  private deveIgnorarRostoAposConfirmacao() {
    return this.deveAguardarSaidaAposConfirmacao();
  }

  private deveAguardarSaidaAposConfirmacao() {
    if (Date.now() < this.aguardandoProximaPessoaAte) {
      return true;
    }

    if (!this.aguardandoSaidaDoRosto) {
      return false;
    }

    if (!this.ultimoFuncionarioRegistradoId || Date.now() > this.ultimoFuncionarioRegistradoAte) {
      this.aguardandoSaidaDoRosto = false;
      return false;
    }

    return true;
  }

  private emitirAvisoFuncionarioRegistrado() {
    const mensagem = this.aguardandoProximaPessoaAte > Date.now()
      ? 'Ponto confirmado. Aguarde a proxima leitura.'
      : 'Seu ponto foi confirmado. Aguarde o periodo seguinte para leitura.';
    this.mensagemCamera = mensagem;

    const agora = Date.now();
    if (agora - this.ultimoAvisoFuncionarioRegistradoEm < 10000) {
      return;
    }

    this.ultimoAvisoFuncionarioRegistradoEm = agora;
    this.servicoVozRegistro.falar(mensagem, this.servicoCameraFacial.ehCameraMobile());
  }

  private deveAguardarConfirmacaoOuCooldown() {
    return this.confirmacaoPontoVisivel
      || Date.now() < this.aguardandoProximaPessoaAte
      || this.servicoEstadoCameraRegistrador.estaEmCooldown(this.registroCooldownAte)
      || this.capturando;
  }

  private registrarRostoAusente() {
    if (!this.aguardandoSaidaDoRosto && !this.ultimoFuncionarioRegistradoId) {
      return;
    }

    if (!this.rostoAusenteDesde) {
      this.rostoAusenteDesde = Date.now();
      return;
    }

    if (Date.now() - this.rostoAusenteDesde >= 1000) {
      this.liberarProximaPessoa();
    }
  }

  private liberarProximaPessoa() {
    this.ultimoFuncionarioRegistradoId = '';
    this.ultimoFuncionarioRegistradoNome = '';
    this.ultimoDescritorRegistrado = [];
    this.ultimoFuncionarioRegistradoAte = 0;
    this.ultimoPontoDataHora = '';
    this.ultimaMensagemBatidaRegistrada = '';
    this.ultimoAvisoFuncionarioRegistradoEm = 0;
    this.aguardandoProximaPessoaAte = 0;
    this.rostoAusenteDesde = 0;
    this.falhasIdentificacaoSequenciais = 0;
    this.aguardandoSaidaDoRosto = false;
  }

  private horarioConfirmacao(dataHora?: string) {
    const data = dataHora ? new Date(dataHora) : new Date();
    if (Number.isNaN(data.getTime())) {
      return '';
    }
    return `Horario: ${data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`;
  }

  private distanciaDescritor(descritorAtual: number[], descritorAnterior: number[]) {
    const soma = descritorAtual.reduce((total, valor, indice) => {
      const diferenca = valor - descritorAnterior[indice];
      return total + diferenca * diferenca;
    }, 0);
    return Math.sqrt(soma);
  }
}
